export default "__VITE_ASSET__CkSin112__"